/** @internal */
export class CompatibilityOptionsImpl {
    constructor() {
        this.data = undefined;
    }
    static getInstance() {
        if (this._instance === undefined) {
            this._instance = new CompatibilityOptionsImpl();
        }
        return this._instance;
    }
}
CompatibilityOptionsImpl._instance = undefined;
